import UserManager from './UserManager'
export default UserManager
